import { render, staticRenderFns } from "./mix-options.vue?vue&type=template&id=24689979&scoped=true"
import script from "./mix-options.vue?vue&type=script&setup=true&lang=js"
export * from "./mix-options.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mix-options.vue?vue&type=style&index=0&id=24689979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24689979",
  null
  
)

export default component.exports